import React from 'react';

import { defineMessages, type MessageDescriptor, useIntl } from 'react-intl-next';

import { IconButton } from '@atlaskit/button/new';
import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import ChevronLeftIcon from '@atlaskit/icon/core/chevron-left';
import { Flex, Inline } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

export type PanelWrapperProps = {
	children: React.ReactNode;
	header: MessageDescriptor;
	onBack: () => void;
};

const i18n = defineMessages({
	backButtonLabel: {
		id: 'ai-audio.audio-player.overflow-menu.back-button-label',
		defaultMessage: 'Back',
		description: 'The label for the back button in the overflow menu panel',
	},
});

const styles = cssMap({
	headerSection: {
		paddingBlock: token('space.050'),
	},
});

export const PanelWrapper = ({
	header,
	onBack,
	children,
}: PanelWrapperProps): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<>
			<Inline xcss={styles.headerSection} space="space.100" alignBlock="center">
				<IconButton
					icon={ChevronLeftIcon}
					appearance="subtle"
					label={formatMessage(i18n.backButtonLabel)}
					spacing="compact"
					testId="overflow-menu-panel-back-button"
					onClick={onBack}
				/>
				<Heading size="xsmall">{formatMessage(header)}</Heading>
			</Inline>
			<Flex>{children}</Flex>
		</>
	);
};
